module.exports = __webpack_public_path__ + "img/dog-sitters.b1582331.png";